"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@app/_components/Accordion/Accordion";
import useTranslate from "@app/_hooks/useTranslate";
import type { ProductPageInfoFragment } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

import { PropsWithChildren } from "react";

type ProductPageInformationProps = PropsWithChildren<{
  className?: string;
  contentfulProductPageInfo?: ProductPageInfoFragment;
}>;

export default function ProductPageInformation({
  className,
  contentfulProductPageInfo,
  children,
}: ProductPageInformationProps) {
  const t = useTranslate();
  if (contentfulProductPageInfo?.parametricsCollection?.items.length === 0) {
    return null;
  }

  return (
    <Accordion
      type="single"
      collapsible
      className={cn("border-gray-150 border-x border-t", className)}
    >
      <AccordionItem value="product-information">
        <AccordionTrigger className="p-4 uppercase">
          {t("productInformation")}
        </AccordionTrigger>
        <AccordionContent className="grid gap-6 p-4 text-base md:grid-cols-2 lg:grid-cols-[repeat(auto-fill,minmax(14rem,1fr))]">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
